(function () {
  var MODAL_ID = 'modal-size-chart';
  var MODAL_NAME = 'size-chart';

  function getDesigner() {
    var path = location.pathname;
    var substring = '/products/';
    if (path.indexOf(substring) === -1) return false;
    var designerUrlPart = path.split(substring)[1];
    if (!designerUrlPart) return false;
    var designer = designerUrlPart.substring(0, designerUrlPart.lastIndexOf('-'));
    return designer || false;
  }

  function getChart(designer) {
    if (typeof CustomDB === 'undefined' || !CustomDB.SizeChart) return false;
    var db = CustomDB.SizeChart;
    if (!db.hasOwnProperty(designer)) return false;
    return db[designer].map(function (row) {
      var parts = row.split('/');
      return {
        size: parts[0],
        bust: parts[1],
        waist: parts[2],
        hip: parts[3]
      };
    });
  }

  function getHtml(designer, chart, unit) {
    var tableContent = '';
    chart.forEach(function (row) {
      tableContent +=
        '<tr>' +
        '<td class="SizeChart__cell SizeChart__cell_size" data-size="' + row.size + '">' + row.size + '</td>' +
        '<td class="SizeChart__cell SizeChart__cell_bust" data-inches="' + row.bust + '">' + row.bust + '</td>' +
        '<td class="SizeChart__cell SizeChart__cell_waist" data-inches="' + row.waist + '">' + row.waist + '</td>' +
        '<td class="SizeChart__cell SizeChart__cell_hip" data-inches="' + row.hip + '">' + row.hip + '</td>' +
        '</tr>';
    });

    return (
      '<div class="SizeChart" data-unit="' + unit + '">' +
      '<div class="SizeChart__top">' +
      '<div class="SizeChart__inputs">' +
      '<input class="SizeChart__input SizeChart__input_bust" type="text" placeholder="Bust">' +
      '<input class="SizeChart__input SizeChart__input_waist" type="text" placeholder="Waist">' +
      '<input class="SizeChart__input SizeChart__input_hip" type="text" placeholder="Hip">' +
      '</div>' +
      '</div>' +
      '<div class="SizeChart__recommendation">Based on your measurements we recommend ordering <span></span></div>' +
      '<div class="SizeChart__designer">' + designer.replace(/-/g, ' ') + ' Size&nbsp;Chart</div>' +
      '<table class="SizeChart__table">' +
      '<thead><tr>' +
      '<th><center>Size</th>' +
      '<th>Bust<br />(<span></span>)</th>' +
      '<th>Waist<br />(<span></span>)</th>' +
      '<th>Hip<br />(<span></span>)</center></th>' +
      '</tr></thead>' +
      '<tbody>' + tableContent + '</tbody>' +
      '</table>' +
      '<div class="SizeChart__convert">' +
      '<span></span>' +
      '<button type="button" class="unit-button active" data-unit="inch">in</button>' +
      '<button type="button" class="unit-button" data-unit="cm">cm</button>' +
      '</div>' +
      '</div>'
    );
  }

  function convertInchToCm(inch) {
    return Math.round(parseFloat(inch) * 2.54);
  }

  function getSizeChartRoot() {
    return document.querySelector('#' + MODAL_ID + ' .SizeChart');
  }

  function clearRowHighlights() {
    var root = getSizeChartRoot();
    if (!root) return;
    root.querySelectorAll('tr.SizeChart__row-highlighted').forEach(function (row) {
      row.classList.remove('SizeChart__row-highlighted');
    });
  }

  function findSizeCell(root, size) {
    if (!root || !size) return null;
    var sizeStr = String(size).trim();
    var cell = root.querySelector('.SizeChart__cell_size[data-size="' + sizeStr + '"]');
    if (cell) return cell;

    var cells = root.querySelectorAll('.SizeChart__cell_size');
    for (var i = 0; i < cells.length; i++) {
      if (cells[i].getAttribute('data-size') === sizeStr) {
        return cells[i];
      }
    }
    return null;
  }

  function highlightSizeRow(size) {
    var root = getSizeChartRoot();
    if (!root) return;

    clearRowHighlights();
    var sizeCell = findSizeCell(root, size);
    if (!sizeCell) return;

    var row = sizeCell.closest('tr');
    if (row) row.classList.add('SizeChart__row-highlighted');
  }

  function getLargestRecommendedSize(sizes, chart) {
    var bestSize = null;
    var bestIndex = -1;

    sizes.forEach(function (size) {
      for (var i = 0; i < chart.length; i++) {
        if (chart[i].size === size && i > bestIndex) {
          bestIndex = i;
          bestSize = size;
        }
      }
    });

    return bestSize;
  }

  function convert(unitNext) {
    var root = getSizeChartRoot();
    if (!root) return;

    var unitCurrent = root.dataset.unit;
    var unitCurrentName = '';
    var cells = root.querySelectorAll('.SizeChart__table td[data-inches]');

    if (unitCurrent === 'cm') {
      unitCurrentName = 'Inches';
      cells.forEach(function (cell) {
        cell.textContent = cell.dataset.inches;
      });
    } else if (unitCurrent === 'inch') {
      unitCurrentName = 'Centimeters';
      cells.forEach(function (cell) {
        cell.textContent = convertInchToCm(cell.dataset.inches);
      });
    }

    root.dataset.unit = unitNext;

    root.querySelectorAll('.SizeChart__input').forEach(function (input) {
      input.value = '';
    });

    var recommendation = root.querySelector('.SizeChart__recommendation');
    if (recommendation) recommendation.style.display = 'none';

    root.querySelectorAll('.SizeChart__table th span').forEach(function (span) {
      span.textContent = unitNext;
    });

    clearRowHighlights();

    root.querySelectorAll('.SizeChart__cell').forEach(function (cell) {
      cell.classList.remove('SizeChart__cell_bold');
    });

    root.querySelectorAll('.SizeChart__convert button').forEach(function (btn) {
      btn.classList.toggle('active', btn.dataset.unit === unitNext);
    });

    var convertLabel = root.querySelector('.SizeChart__convert span');
    if (convertLabel) {
      convertLabel.textContent = 'Measurements displayed in ' + unitCurrentName;
    }
  }

  function initSizeChartEvents() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal || modal.dataset.sizeChartEventsBound === 'true') return;
    modal.dataset.sizeChartEventsBound = 'true';

    modal.addEventListener('click', function (evt) {
      var unitBtn = evt.target.closest('.unit-button');
      if (!unitBtn || unitBtn.classList.contains('active')) return;
      convert(unitBtn.dataset.unit);
    });

    modal.addEventListener('input', function (evt) {
      if (!evt.target.classList.contains('SizeChart__input')) return;

      var root = getSizeChartRoot();
      if (!root) return;

      var unit = root.dataset.unit;
      var chart = getChart(getDesigner());
      if (!chart) return;

      var sizes = [];

      function findMeasure(measure) {
        var input = root.querySelector('.SizeChart__input_' + measure);
        var value = input ? input.value : '';
        if (value === '') return;

        for (var i = 0; i < chart.length; i++) {
          var dbValue = chart[i][measure];
          var convertedValue = unit === 'cm' ? convertInchToCm(dbValue) : parseFloat(dbValue);
          if (convertedValue >= parseFloat(value)) {
            sizes.push(chart[i].size);
            root.querySelectorAll('.SizeChart__cell_' + measure).forEach(function (cell) {
              cell.classList.remove('SizeChart__cell_bold');
            });
            root.querySelectorAll('.SizeChart__cell_' + measure + '[data-inches="' + dbValue + '"]').forEach(function (cell) {
              cell.classList.add('SizeChart__cell_bold');
            });
            break;
          }
        }
      }

      findMeasure('bust');
      findMeasure('waist');
      findMeasure('hip');

      var re = /^[\d.]+$/;
      var bustInput = root.querySelector('.SizeChart__input_bust');
      var waistInput = root.querySelector('.SizeChart__input_waist');
      var hipInput = root.querySelector('.SizeChart__input_hip');
      var recommendation = root.querySelector('.SizeChart__recommendation');

      clearRowHighlights();

      if (
        bustInput && waistInput && hipInput && recommendation &&
        re.test(bustInput.value) &&
        re.test(waistInput.value) &&
        re.test(hipInput.value) &&
        sizes.length
      ) {
        var maxSize = getLargestRecommendedSize(sizes, chart);
        if (maxSize) {
          recommendation.style.display = 'flex';
          recommendation.querySelector('span').textContent = 'size ' + maxSize;
          highlightSizeRow(maxSize);
        } else {
          recommendation.style.display = 'none';
        }
      } else if (recommendation) {
        recommendation.style.display = 'none';
      }
    });
  }

  function openTab(evt, tabName) {
    var tabsRoot = document.getElementById('custom-tabs');
    if (!tabsRoot) return;

    tabsRoot.querySelectorAll('.custom.tab-content').forEach(function (content) {
      content.classList.remove('active');
      content.style.display = 'none';
    });

    tabsRoot.querySelectorAll('.custom.tab').forEach(function (tab) {
      tab.classList.remove('active');
    });

    var panel = document.getElementById(tabName);
    if (panel) {
      panel.classList.add('active');
      panel.style.display = 'block';
    }

    if (evt && evt.currentTarget) {
      evt.currentTarget.classList.add('active');
    }
  }

  function initTabs() {
    var tabsRoot = document.getElementById('custom-tabs');
    if (!tabsRoot || tabsRoot.dataset.tabsBound === 'true') return;
    tabsRoot.dataset.tabsBound = 'true';

    tabsRoot.querySelectorAll('.custom.tab').forEach(function (tab) {
      tab.addEventListener('click', function (evt) {
        openTab(evt, tab.dataset.tab);
      });
    });

    var defaultTab = document.getElementById('defaultOpen');
    if (defaultTab) defaultTab.click();
  }

  function initCollapsible() {
    var headings = document.querySelectorAll('#' + MODAL_ID + ' .tab-collapsible-heading');
    headings.forEach(function (heading) {
      if (heading.dataset.collapsibleBound === 'true') return;
      heading.dataset.collapsibleBound = 'true';

      heading.addEventListener('click', function () {
        var content = this.nextElementSibling;
        var btn = this.querySelector('.tab-collapsible-btn');
        var isOpen = content && content.classList.contains('active');

        if (!isOpen) {
          document.querySelectorAll('#' + MODAL_ID + ' .tab-collapsible').forEach(function (collapsible) {
            var collapsibleBtn = collapsible.querySelector('.tab-collapsible-btn');
            var collapsibleContent = collapsible.querySelector('.content');
            if (collapsibleBtn) collapsibleBtn.classList.remove('active');
            if (collapsibleContent) collapsibleContent.classList.remove('active');
          });
        }

        if (btn) btn.classList.toggle('active');
        if (content) content.classList.toggle('active');
      });
    });
  }

  function initSizeChart() {
    var container = document.querySelector('#' + MODAL_ID + ' .SizeChartContainer');
    if (!container || container.dataset.sizeChartReady === 'true') return;

    var designer = getDesigner();
    if (!designer) return;

    var chart = getChart(designer);
    if (!chart) return;

    container.innerHTML = getHtml(designer, chart, 'cm');
    container.dataset.sizeChartReady = 'true';

    var root = getSizeChartRoot();
    if (!root) return;

    var defaultBtn = root.querySelector('.SizeChart__convert button.active');
    if (defaultBtn) convert(defaultBtn.dataset.unit);
  }

  function initModal() {
    var el = document.getElementById(MODAL_ID);
    if (!el || el.dataset.sizeChartModalReady === 'true') return;
    if (typeof theme === 'undefined' || !theme.Modals) return;

    new theme.Modals(MODAL_ID, MODAL_NAME, { solid: true });
    el.dataset.sizeChartModalReady = 'true';

    if (window.innerWidth < 980) {
      el.style.width = '100%';
      el.style.height = '100%';
    }
  }

  function init() {
    initModal();
    initTabs();
    initCollapsible();
    initSizeChart();
    initSizeChartEvents();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
